import React, {Component, PropTypes} from 'react';
import './RouteItem.scss';

class RouteItem extends Component {

  static propTypes = {
      counter: PropTypes.number,
      text: PropTypes.string,
  };

  static defaultProps = {
      counter: 1,
      text: 'Location',
  };

  render() {
      return (
        <div className="RouteItem-routePoint">
            <div>
                <div className="RouteItem-routePointMarker">{this.props.counter}</div>
            </div>
            <div className="RouteItem-routePointText">
                {this.props.text}
            </div>
        </div>
      );
  }
}


export default RouteItem;



// WEBPACK FOOTER //
// ./client/components/InfoBlockRoute/RouteItem.js